import script from "./MultiSongConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSongConfig.vue?vue&type=script&setup=true&lang=js"

import "./MultiSongConfig.vue?vue&type=style&index=0&id=151da104&scoped=true&lang=css"
script.__scopeId = "data-v-151da104"

export default script